import { StatusBadgeStyled } from './styles/StatusBadgeStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'
import { type Enum } from '@ui/utils/enums'

export const StatusBadgeStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INACTIVE: 'inactive',
  INCOMPLETE: 'incomplete',
  IN_PROGRESS: 'inProgress',
} as const

export type StatusBadgeStatus = Enum<typeof StatusBadgeStatuses>

export interface IStatusBadgeProps {
  /**
   * Unique identifier for analytics tracking.
   */
  analyticsId?: string
  type: StatusBadgeStatus
  text: string
  size?: 'small' | 'medium'
  'aria-label'?: string
  className?: string
}

export const StatusBadge = ({
  analyticsId,
  type,
  text,
  size = 'medium',
  'aria-label': ariaLabel,
  className,
}: IStatusBadgeProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <StatusBadgeStyled
      type={type}
      size={size}
      aria-label={ariaLabel}
      className={className}
      {...analyticsProps}
    >
      <span>{text}</span>
    </StatusBadgeStyled>
  )
}
